import { render } from "./ShoppingPaymentBox.vue?vue&type=template&id=fa1dbf84"
import script from "./ShoppingPaymentBox.vue?vue&type=script&lang=js"
export * from "./ShoppingPaymentBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__